import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import { IDomainFormValues } from '../../../../@types/model/masterData/domain/domainFormValues';
import { PillButton, ControlledTextField } from '@zz2/zz2-ui';
import { ControlledLabelledCheckBox } from '../../../../components/input/form/ControlledLabelledCheckBoxWrapper';
import CustomReactHookFormDevTools from '../../../../components/devtools/ReactHookFormDevTools';
import DomainModelHelper from '../../../../@types/model/masterData/domain/domainModelHelper';
import { yupResolver } from '@hookform/resolvers/yup';

interface IDomainFormProps {
    isLoading : boolean;
    initialValues : IDomainFormValues;
    onSubmit : (values : IDomainFormValues) => void;
    onClose : () => void;
}

const DomainForm = (props : IDomainFormProps) : React.ReactElement => {
    const { handleSubmit, control, formState: { isValid, isDirty }, trigger } = useForm<IDomainFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(DomainModelHelper.formSchema()),
        mode: 'onChange',
    });

    /*================================================================================================================
     *                                                  Queries
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Effects
     * ==============================================================================================================*/

    useEffect(() => {
        trigger();
    }, []);

    /*================================================================================================================
     *                                                  Async Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Handler Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Memos
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Render Methods
     * ==============================================================================================================*/

    return (
        <div>
            <form onSubmit={handleSubmit(props.onSubmit)} className={'fdc p20'}>
                <ControlledTextField
                    className={'mb10 w500'}
                    name={'domainName'}
                    label={'Name'}
                    control={control}
                    defaultValue={props.initialValues.domainName}
                    size={'small'}
                />
                <div className={'fdr jcfs mb5'}>
                    <ControlledLabelledCheckBox
                        className={'p0'}
                        name={'isActive'}
                        label={'Is Active'}
                        control={control}
                        defaultValue={props.initialValues.isActive}
                        disabled={props.initialValues.isActive}
                    />
                </div>
                <div className={'fdr flx1 aic jcfe'}>
                    <Button 
                        className={'cpd mr20'}
                        onClick={props.onClose} 
                        type={'reset'}>
                        CANCEL
                    </Button>
                    <PillButton
                        className={'pl30 pr30'}
                        text={'SAVE'}
                        size={'small'}
                        type={'submit'}
                        color={'secondary'}
                        disabled={ !isDirty || !isValid || props.isLoading }
                    />
                </div>
            </form>
            <CustomReactHookFormDevTools control={control} />
        </div>
    );
};

export default DomainForm;
